import config from "appConfig";

const walls = {
  "0": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/0.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-0.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-1.svg`,
  },
};

export default walls;
